import {FormInstance} from 'antd/es/form';
import {get} from 'lodash-es';

import {IReferenceParamKey} from 'entities/metadata';

export const getReferenceURLQueryParamsFromForm = (form?: FormInstance, referenceParamsKeys?: IReferenceParamKey[]) => {
    const result: Record<string, string> = {};
    referenceParamsKeys?.forEach(({from, to}) => {
        const value = get(form?.getFieldsValue(), from);
        if (to && value) result[to] = value;
    });
    return result;
};
